var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconaEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    rx: 2,
    fill: "#000000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0999 12.346C11.5188 12.1014 11.8493 11.7508 12.0918 11.2939H15.1999C14.8695 12.5058 14.2135 13.4597 13.2328 14.1557C12.2517 14.8521 11.0723 15.2001 9.69503 15.2001C8.31779 15.2001 7.15134 14.8547 6.16531 14.1639C5.17883 13.4731 4.50361 12.5377 4.1401 11.3576H2.84995V9.93854H3.89136C3.88019 9.84293 3.87483 9.69951 3.87483 9.50786C3.87483 9.30588 3.88019 9.15169 3.89136 9.04532H2.84995V7.6103H4.15617C4.52013 6.44102 5.1949 5.51377 6.18139 4.82813C7.16742 4.14293 8.33878 3.80011 9.69458 3.80011C11.0504 3.80011 12.2512 4.15068 13.2323 4.85225C14.213 5.55382 14.869 6.51036 15.1995 7.72228H12.0913C11.8489 7.26533 11.5179 6.91691 11.0995 6.67789C10.6806 6.43886 10.201 6.31914 9.66109 6.31914C9.12118 6.31914 8.65808 6.43068 8.2392 6.65377C7.82031 6.87686 7.48404 7.19599 7.23083 7.6103H9.992V9.04532H6.76818C6.75702 9.14093 6.75166 9.29511 6.75166 9.50786C6.75166 9.69908 6.75702 9.8425 6.76818 9.93854H9.992V11.3576H7.19779C7.451 11.7935 7.78995 12.1285 8.21464 12.362C8.63888 12.5958 9.12118 12.7125 9.66109 12.7125C10.201 12.7125 10.6806 12.5906 11.0995 12.346H11.0999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaEuro);
export default __webpack_public_path__ + "static/media/icona_euro.d4660a94fb20d4476a4420ad3bfe1336.svg";
export { ForwardRef as ReactComponent };